import { render } from "./carruselcomponent2_ingles.vue?vue&type=template&id=0f6e8a9f&scoped=true"
import script from "./carruselcomponent2_ingles.vue?vue&type=script&lang=js"
export * from "./carruselcomponent2_ingles.vue?vue&type=script&lang=js"

import "./carruselcomponent2_ingles.vue?vue&type=style&index=0&id=0f6e8a9f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6e8a9f"]])

export default __exports__